import { endPoints } from 'api/';
import { UPDATE_INTEGRATION } from 'actions/types';

export function updateIntegration(id, payload) {
  /**
   * @param {Function} dispatch
   */
  return function (dispatch) {
    const action = {
      type: UPDATE_INTEGRATION,
      /**
       * @param {Function} apiClient
       */
      request: async function (apiClient) {
        return await apiClient(endPoints.UPDATE_INTEGRATION, payload, id);
      },
    };
    dispatch(action);
  };
}
